import { render, staticRenderFns } from "./plans.vue?vue&type=template&id=68e52719&scoped=true"
import script from "./plans.vue?vue&type=script&lang=js"
export * from "./plans.vue?vue&type=script&lang=js"
import style0 from "./plans.vue?vue&type=style&index=0&id=68e52719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e52719",
  null
  
)

export default component.exports